export default "__VITE_ASSET__CWonCZvb__"